import { FC } from 'react'

import { Page, TextSkeleton } from '@revolut-internal/ui-kit'

import { useDataLastUpdate } from 'modules/Monitoring/hooks/useDataLastUpdate'
import { getFormattedDateTime } from 'modules/Monitoring/utils/formatTimeAndDuration'

export const PageHeader: FC = () => {
  const { lastUpdate, isLoading } = useDataLastUpdate()

  return (
    <Page.Header
      description={
        isLoading ? (
          <TextSkeleton size={20} />
        ) : (
          (lastUpdate && `Last update: ${getFormattedDateTime(lastUpdate)}`) || null
        )
      }
    >
      Real Time Monitoring
    </Page.Header>
  )
}
